export default "__VITE_ASSET__f8d31839__"